import Vue from 'vue';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { faFileImage } from '@fortawesome/pro-light-svg-icons';
import { faYoutube } from '@awesome.me/kit-4c37f718d5/icons/classic/brands';
import { faShirtExpand, faImageCirclePlus } from '@awesome.me/kit-4c37f718d5/icons/kit/custom';

/*
 * Pro icons are on v7 while svg-core stays on v6, because vue-fontawesome 2 (Vue 2) only supports svg-core <= 6.
 * The icon data format is the same; only the TypeScript prefix/name unions differ, hence the cast.
 */
const proIcons = [faFileImage, fas, far] as unknown as Parameters<typeof library.add>;

/* add icons to the library */
library.add(...proIcons);
library.add(faYoutube);
library.add(faShirtExpand, faImageCirclePlus);

/* replace <i class="fas fa-*"> elements with SVGs from the library */
dom.watch();

Vue.component('font-awesome-icon', FontAwesomeIcon);
